import { useEffect, useState } from "react";
import api from "@/lib/api";
import ListingCard from "@/components/ListingCard";
import { Heart } from "lucide-react";

export default function Watchlist() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/watchlist").then(({ data }) => setItems(data)); }, []);
  return (
    <div className="mx-auto max-w-7xl px-4 py-8 sm:px-6">
      <h1 className="mb-6 flex items-center gap-2 font-heading text-2xl font-bold text-slate-900"><Heart className="h-6 w-6 text-primary" /> Watchlist</h1>
      {items.length === 0 ? (
        <div className="rounded-2xl border border-dashed border-slate-300 py-20 text-center text-slate-500" data-testid="watchlist-empty">Save items you love and they'll appear here.</div>
      ) : (
        <div className="grid grid-cols-2 gap-6 sm:grid-cols-3 lg:grid-cols-4">{items.map((l, i) => <ListingCard key={l.id} listing={l} index={i} />)}</div>
      )}
    </div>
  );
}
